<template>
    <section
        :class="[
            `w-[300px] bg-white h-[100vh] flex-col relative duration-100 hidden md:flex`,
            { 'w-[53px] overflow-hidden': isCollapsed },
        ]"
        id="app-sidebar-guest"
    >
        <div
            v-if="!defaultCollapsed"
            :class="[
                `absolute -right-4 top-6 z-[101] rounded-full w-8 h-8 bg-gray-100 flex items-center justify-center hover:bg-gray-200`,
                { 'right-3': isCollapsed },
            ]"
            @click="isCollapsed = !isCollapsed"
        >
            <ion-icon
                v-if="!isCollapsed"
                name="chevron-back-outline"
            ></ion-icon>
            <ion-icon v-else name="chevron-forward-outline"></ion-icon>
        </div>
        <a href="/">
            <img
                v-if="!isCollapsed"
                src="/img/clipboard logo.jpg"
                alt="Clipboard Nation Logo"
                class="
                    w-[35%]
                    h-auto
                    mx-auto
                    mt-10
                    border-b-2
                    pb-6
                    border-gray-100
                "
            />
        </a>
        <a href="/new-forum" class="mx-auto mt-4" v-if="backHref">
            <ion-icon
                v-if="backHref"
                name="home-outline"
                class="text-[24px]"
            ></ion-icon>
        </a>
        <a :href="backHref" class="mx-auto mt-4" v-if="backHref">
            <ion-icon
                v-if="backHref"
                name="arrow-back-circle-outline"
                class="text-[24px]"
            ></ion-icon>
        </a>
        <div v-if="isCollapsed" class="mt-24"></div>
        <slot class="my-24"></slot>
    </section>
</template>

<script>
export default {
    name: "AppSidebarGuest",
    props: ["defaultCollapsed"],
    watch: {
        isCollapsed() {
            this.$root.sidebarCollapsed = this.isCollapsed;
        },
    },
    mounted() {
        this.$root.sidebarCollapsed = this.isCollapsed;
    },
    data() {
        return {
            isCollapsed: !!this.defaultCollapsed,
        };
    },
};
</script>

<style scoped></style>
